import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getMyIdeas } from "../api/ideas";
import IdeaCard from "../components/ideas/IdeaCard";
import IdeasTopbar from "../components/ideas/IdeasTopbar";
import IdeaCreateModal from "../components/ideas/IdeaCreateModal";
import usePageTitle from "../hooks/usePageTitle";
import "../styles/ideas.css";

/**
 * Кабинет идей: список своих, любых статусов.
 * Гость отправляется на /login.
 */
export default function MyIdeasPage() {
  usePageTitle("Мои идеи — Рублокс");
  const { isAuthenticated, initializing } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!initializing && !isAuthenticated) {
      navigate("/login?back=/ideas/my");
    }
  }, [initializing, isAuthenticated, navigate]);

  useEffect(() => {
    if (!isAuthenticated) return;
    const ctl = new AbortController();
    getMyIdeas({ signal: ctl.signal })
      .then((d) => setItems(d.items || []))
      .catch((e) => {
        if (e.name !== "AbortError") setErr(e.message);
      });
    return () => ctl.abort();
  }, [isAuthenticated]);

  return (
    <div className="idz-page">
      <IdeasTopbar />
      <main className="idz-container" style={{ paddingTop: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 26 }}>Мои идеи</h1>
          <button className="idz-btn-primary" onClick={() => setOpenModal(true)}>
            Предложить идею
          </button>
        </div>

        {err && <div className="idz-err">{err}</div>}

        {items == null && !err && (
          <div className="idz-loading">Загружаю твои идеи…</div>
        )}

        {items != null && items.length === 0 ? (
          <div className="idz-empty">
            Ты пока ничего не предлагал. <br />
            <Link to="/ideas" style={{ color: "#3357ff", fontWeight: 600 }}>
              Посмотри что предлагают другие
            </Link>
            {" или "}
            <button
              type="button"
              className="idz-btn-secondary"
              style={{ marginTop: 8 }}
              onClick={() => setOpenModal(true)}
            >
              Предложи свою
            </button>
          </div>
        ) : (
          items != null && (
            <div className="idz-row">
              {items.map((i) => <IdeaCard key={i.id} idea={i} />)}
            </div>
          )
        )}
      </main>

      <IdeaCreateModal open={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
}
